module.exports = __webpack_public_path__ + "assets/images/2f9b3f959aa7745cc80a43c9b0049520.avif";